import { gql } from '@apollo/client';
import {
  getContextQueryVariables,
  getContextFilterClientExports,
  getContextFiltersQueryArguments,
} from '../../../utils/helpers/contextFilters';
import { QUERY_CONTEXT } from './TeamDepthChart.constants';

export const GET_DEPTH_CHART_PLAYERS = gql`
  query GetDepthChart(
    $teamId: Int!
    $competitionId: Int!
    $seasonId: Int!
    $offense: Boolean!
    $groupByAlignment: Boolean!
    $personnel: PersonnelFilter
    ${getContextQueryVariables(QUERY_CONTEXT)}
  ) {
    selectedCompetitionId @client @export(as: "competitionId")
    selectedSeasonId @client @export(as: "seasonId")
    selectedTeamId @client @export(as: "teamId")
    ${getContextFilterClientExports(QUERY_CONTEXT)}

    depthChart(
      teamId: $teamId
      offense: $offense
      groupByAlignment: $groupByAlignment
      playFilters: {
        competitionId: $competitionId
        seasonId: $seasonId
        personnel: $personnel
        ${getContextFiltersQueryArguments(QUERY_CONTEXT)}
      }
    ) {
      players {
        player {
          id
          name
        }
        rosterPosition
        alignmentPosition
        snapCount
        snapRate
        usageRate
        lateDownsRate
        jerseyNumber
      }
    }
  }
`;
